import { Injectable } from '@angular/core';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { environment } from '../../environments/environment';
import { User } from '../models/user';
import { AuthRequest } from '../models/authRequest';
import { Token } from '../models/token';
import { RegisterRequest } from '../models/registerRequest';
import { ApiPage } from '../models/api-page';
import { Country } from '../models/country';
import { Observable } from 'rxjs';

@Injectable()
export class UserService {

  constructor(private http: HttpClient) { }

  getUser(): Observable<User> {
    return this.http.get<User>(
      environment.apiName + '/users/me',
      {
        headers: this.getRequestHeaders()
      }
    );
  }

  auth(body: AuthRequest): Observable<Token> {
    return this.http.post<Token>(environment.apiName + '/auth', body);
  }

  registerUser(body: RegisterRequest): Observable<any> {
    return this.http.post<Token>(environment.apiName + '/register', body);
  }

  getRequestHeaders() {
    return new HttpHeaders(
        {
          'Content-Type': 'application/json',
          Accept: 'application/json',
          Authorization: 'Bearer ' + localStorage.getItem('token')
        }
    );
  }

  getCountries(): Observable<ApiPage<Country>> {
    return this.http.get<ApiPage<Country>>(
      environment.apiName + '/countries',
      {
        headers: this.getRequestHeaders()
      }
    );
  }

  resetPassword(email: string): Observable<void> {
    return this.http.post<void>(
      environment.apiName + '/user/recover',
      {
        email: email
      }
    );
  }

  resendActivationEmail(): Observable<any> {
    return this.http.post<any>(environment.apiName + '/user/resend-activation-email', {},
      {
        headers: this.getRequestHeaders()
      }
    );
  }
}
